import { create } from "zustand";

export interface MonitorProgress {
  stage: string;
  message: string;
  currentPaper: number;
  totalPapers: number;
  scored: number;
  totalToScore: number;
  newPapersAdded: number;
  percent: number;
  autoDismissed?: number;
  autoDismissThreshold?: number;
}

interface MonitorState {
  isRunning: boolean;
  isCompleted: boolean;
  error: string | null;
  jobId: string | null;
  progress: MonitorProgress;

  startMonitor: (jobId: string) => void;
  updateProgress: (update: Partial<MonitorProgress>) => void;
  completeMonitor: (message: string) => void;
  failMonitor: (error: string) => void;
  resetMonitor: () => void;
}

const initialProgress: MonitorProgress = {
  stage: "",
  message: "",
  currentPaper: 0,
  totalPapers: 0,
  scored: 0,
  totalToScore: 0,
  newPapersAdded: 0,
  percent: 0,
};

export const useMonitorStore = create<MonitorState>((set, get) => ({
  isRunning: false,
  isCompleted: false,
  error: null,
  jobId: null,
  progress: { ...initialProgress },

  startMonitor: (jobId) =>
    set({
      isRunning: true,
      isCompleted: false,
      error: null,
      jobId,
      progress: { ...initialProgress, message: "Starting monitor..." },
    }),

  updateProgress: (update) =>
    set((state) => ({
      progress: { ...state.progress, ...update },
    })),

  completeMonitor: (message) =>
    set({
      isRunning: false,
      isCompleted: true,
      progress: { ...get().progress, message, percent: 100 },
    }),

  failMonitor: (error) =>
    set({
      isRunning: false,
      error,
    }),

  resetMonitor: () =>
    set({
      isRunning: false,
      isCompleted: false,
      error: null,
      jobId: null,
      progress: { ...initialProgress },
    }),
}));
